import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiBriefcase, FiClock, FiCheckCircle } from 'react-icons/fi';

const KpiCards = ({ stats }) => {
  const appStats = stats?.applicationStats || {};
  const cards = [
    {
      label: 'Total Resumes',
      value: stats?.totalResumes ?? 0,
      icon: <FiFileText className="h-6 w-6 text-white" />,
      gradient: 'from-primary-500 to-primary-600',
      border: 'border-primary-500',
      bg: 'bg-primary-50',
      link: '/resumes',
      textColor: 'text-primary-600',
    },
    {
      label: 'Total Jobs',
      value: stats?.totalJobs ?? 0,
      icon: <FiBriefcase className="h-6 w-6 text-white" />,
      gradient: 'from-blue-500 to-blue-600',
      border: 'border-blue-500',
      bg: 'bg-blue-50',
      link: '/jobs/saved',
      textColor: 'text-blue-600',
    },
    {
      label: 'Active Applications',
      value: (appStats.applied ?? 0) + (appStats.interviewing ?? 0),
      icon: <FiClock className="h-6 w-6 text-white" />,
      gradient: 'from-cyan-500 to-blue-500',
      border: 'border-cyan-500',
      bg: 'bg-cyan-50',
      link: '/applications',
      textColor: 'text-cyan-600',
    },
    {
      label: 'Offers',
      value: appStats.offered ?? 0,
      icon: <FiCheckCircle className="h-6 w-6 text-white" />,
      gradient: 'from-green-500 to-green-600',
      border: 'border-green-500',
      bg: 'bg-green-50',
      link: '/applications?status=offered',
      textColor: 'text-green-600',
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-2">
      {cards.map((c) => (
        <Link key={c.label} to={c.link} className={`bg-white overflow-hidden shadow-sm rounded-lg transition-all hover:shadow-md border-l-3 ${c.border} no-underline`}>
          <div className="px-3 py-2">
            <div className="flex items-center gap-2">
              <div className={`flex-shrink-0 bg-gradient-to-r ${c.gradient} rounded-md p-1.5`}>
                {React.cloneElement(c.icon, { className: 'h-4 w-4 text-white' })}
              </div>
              <div className="min-w-0 flex-1">
                <dt className="text-[10px] font-medium text-gray-500 truncate leading-tight">{c.label}</dt>
                <dd className="text-lg font-semibold text-gray-900 leading-tight">{c.value}</dd>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default KpiCards;
